module.exports = __webpack_public_path__ + "static/unit_01_icon-145ec54000df1506dbd2537ddef2586e.svg";